import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { debounce } from '../../utils/helpers';

// This custom portal is used to re-render a component inserted via portal after screen-resize.
const ResponsivePortal = ({ component, portalRootId }) => {
  const [resized, setResized] = useState(false);
  const mount = document.getElementById(portalRootId);

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setResized(true);
    }, 2000);
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  useEffect(() => {
    if (resized) {
      createPortal(component, mount);
      setResized(false);
    }
  }, [mount, resized, component]);

  return createPortal(component, mount);
};

export default ResponsivePortal;
